<script lang="ts">
    import ErrorInline from '../../shared/ErrorInline.svelte';

    export let valid: boolean = true;
    export let errors: string[] = [];
    export let withPadding: boolean = false;
</script>

<div class:fixMargin={withPadding}>
    <div class="error-bounduary" class:invalid-input={!valid} class:withPadding>
        <div class="content">
            <slot />
        </div>
        {#if errors.length > 0}
            <div class="errors">
                {#each errors as error}
                    <ErrorInline text={error} />
                {/each}
            </div>
        {/if}
    </div>
</div>

<style>
    .error-bounduary {
        border-radius: 3px;
    }
    .withPadding {
        padding: 10px;
    }
    .fixMargin {
        margin: -10px;
    }
    .content {
        display: flex;
        flex-direction: row;
        column-gap: 15px;
        flex-wrap: wrap;
        row-gap: 10px;
    }
    .errors {
        display: flex;
        flex-direction: column;
        row-gap: 5px;
        padding-top: 10px;
    }
</style>
